var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 76,
    viewBox: "0 0 91 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7505 34.6065C12.6401 32.6018 11.7362 30.2554 9.73144 29.3658C7.72672 28.4761 5.38038 29.3801 4.49073 31.3848C3.60108 33.3895 4.50502 35.7358 6.50974 36.6255C8.51446 37.5151 10.8608 36.6112 11.7505 34.6065Z",
    fill: "#8E4DD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7634 19.128L53.7329 23.8471L53.6087 30.7436L48.8896 25.713L41.9932 25.5889L47.0234 20.8696L47.1479 13.9733L51.867 19.0039L58.7634 19.128Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4744 62.9845L71.4441 67.7037L71.3197 74.6L66.6004 69.5694L59.7041 69.4453L64.7344 64.7261L64.8588 57.8298L69.5779 62.8599L76.4744 62.9845Z",
    fill: "#00A98F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSparkles);
export default __webpack_public_path__ + "static/media/right-sparkles.1f3973e473d264b704d4beb4d57c2008.svg";
export { ForwardRef as ReactComponent };